import { Registration } from './registration'

export { Registration }
